//-----------------------------------------------------------------------------
// Copyright 2021-2022 by banbutsu dcp GmbH. Confidential. All rights reserved.
//-----------------------------------------------------------------------------
// Project: platform frontend
// Author:  bamidele.awotunde@banbutsu.com
//
// this component helps to switch between the experiences landing page and
//  equipment landing page
//

// Further details regarding endpoints on
// `https://git.iconmobile.com/banbutsu/dev/-/tree/master/src/platform/cmd/srv_portal`
//-----------------------------------------------------------------------------
import React from "react";
import styled from "styled-components";
import { envDomainName, getPartnerConfiguration } from "../Utils/windowHelper";
import { translate } from "../Utils/language";

type Props = {
  language: string;
  category: string;
  handleChange: Function;
  referer: string;
  partner_user: string;
};

const ShopGallerySwitch: React.FC<Props> = ({ language, category, handleChange, referer, partner_user }) => {
  const configuration = getPartnerConfiguration(referer);
  const showShopgallerySwitch = configuration?.SHOW_SHOPGALLERY_SWITCH;
  if (!showShopgallerySwitch) return null;

  return (
    <Wrapper>
      <form>
        <PackageSelectWrapper>
          <label htmlFor="experiences" className={referer === "etravel" ? "label active" : ""}>
            <input type="radio" value="experiences" name="recommendation" id="experiences" className="input" required />
            <div className="inner-label">{translate(language, "Discover")}</div>
          </label>

          <label
            htmlFor="equipment"
            className={"label"}
            onClick={() => {
              window.location.href = `${envDomainName}/gallery/${referer}?pu=${partner_user}&l=${language}`;
            }}
          >
            <input className="input" required type="radio" name="recommendation" />
            <div className="inner-label">{translate(language, "My Experiences")}</div>
          </label>
          <label
            htmlFor="equipment"
            className={"label"}
            onClick={() => {
              window.location.href = `${envDomainName}/history/${referer}?pu=${partner_user}&l=${language}`;
            }}
          >
            <input className="input" required type="radio" name="recommendation" />
            <div className="inner-label">{translate(language, "My Bookings")}</div>
          </label>
        </PackageSelectWrapper>
      </form>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 1.2rem 0.75rem 2rem;
`;

const PackageSelectWrapper = styled.div`
  display: flex;
  align-items: stretch;
  border-radius: var(--radius-buttons);
  border: 1px solid var(--clr-primary-1);
  box-shadow: var(--box-shadow);
  background: white;
  width: 95%;
  margin: auto;
  margin-bottom: -2.5rem;
  /* height: 2.5rem; */
  padding: 0.3em;

  .label {
    padding: 0.75rem 0.5rem;
    text-align: center;
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    transition: var(--transition);
    text-transform: capitalize;
    font-family: var(--p-medium);
    color: var(--clr-primary-1);
    background: white;
    border-radius: var(--radius-buttons);
    font-weight: 600;
    font-size: 12px;
  }

  .active {
    color: white;
    transition: var(--transition);
    background: var(--clr-primary-1);
    font-family: var(--p-bold);
    /* width: 100%; */
  }

  .inner-label {
    margin: auto;
  }

  .input {
    display: none;
  }

  @media screen and (min-width: 800px) {
    width: 30vw;
    min-width: 300px;
    margin: 0 auto;
  }
`;

export default ShopGallerySwitch;
